/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Delivery_SaleInputs */

const vi_pos_delivery_sale = /** @type {(inputs: Pos_Delivery_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán giao hàng`)
};

/**

* @param {Pos_Delivery_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_delivery_sale = /** @type {((inputs?: Pos_Delivery_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Delivery_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_delivery_sale(inputs)
});